import { GET_SUB_SUB_CAT } from "../actions/types";

const initialState=[]
export default function subSubCategories(state = initialState, action) {
    switch (action.type) {
      case GET_SUB_SUB_CAT:
        return action.payload;
      default:
        return state;
    }
  }